import { atom } from 'recoil'
import { MOBILE_BREAKPOINT } from '../../../../app/utils/constants'

export const asideMenuIsOpen = atom({
    key: 'asideMenuIsOpen',
    default: MOBILE_BREAKPOINT >= window.innerWidth ? false : true
})
